class Brands {
    constructor(element) {
        this.container = typeof (element) === 'string' ? document.querySelector(element) : element;
    }

    init() {
        this._rightAligned = !!this.container.querySelector('.right-aligned');
        this.triggers = this.container.querySelectorAll('.brand-trigger');
        this.targetContainer = this.container.querySelector('.brand-target-container');
        this.tabBackgrounds = this.container.querySelectorAll('.tab-background');
        this.targets = this.targetContainer.querySelectorAll('.brand-target');
        this.tabs = Array.from(this.container.querySelectorAll('.brand-tab'));
        this.targetId = this.container.querySelector('[target-id]').getAttribute('target-id');
        this.modal = document.querySelector('#' + this.targetId);
        this.modalContainer = this.modal.querySelector('.message');
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', function () {
                this._triggerSwitch(trigger);
            }.bind(this));
        });

        this.tabs.forEach(tab => {
            tab.addEventListener('click', function () {
                this._filterTargets(tab);
            }.bind(this));
        });
        this._setHeight();
        window.addEventListener('resize', this._setHeight.bind(this));
        this._currentTrigger = 0;
        this._currentTab = 0;
    }

    _triggerSwitch(element) {
        var parent = element.parentNode;
        var index = Array.from(parent.parentNode.children).indexOf(parent);
        this._switchBrand(index);
    }

    _switchBrand(index) {
        if (!this._locked) {
            var isLarge = Foundation.MediaQuery.atLeast('large');
            if (index !== this._currentTrigger || !isLarge) {
                this._locked = true;
                this.triggers[this._currentTrigger].classList.remove('active');
                this.triggers[index].classList.add('active');
                if (isLarge) {
                    var tl = new TimelineLite({
                        onComplete: function () {
                            this._currentTrigger = index;
                            this._locked = false;
                        }.bind(this)
                    })
                        .set(this.targets[index], { display: 'block' })
                        .addLabel('start')
                        .to(this.targets[this._currentTrigger], { x: this._rightAligned ? '-50%' : '50%', autoAlpha: 0, duration: .4 }, 'start')
                        .fromTo(this.targets[index], { x: this._rightAligned ? '10%' : '-10%', autoAlpha: 0 }, { x: '0%', autoAlpha: 1, duration: .4, delay: -.2 });
                }
                else {
                    this.modalContainer.innerHTML = this.targets[index].innerHTML;
                    $(this.modal).foundation('open');
                    this._currentTrigger = index;
                    this._locked = false;
                }
            }
        }
    }

    _setHeight() {
        if (this.tabs.length) {
            var text = this.container.querySelector('.text');
            text.style.height = '';
            var hiddens = Array.from(this.container.querySelectorAll('.hidden'));
            hiddens.forEach(hidden => {
                hidden.classList.remove('hidden');
            });
            text.style.height = text.clientHeight + 'px';
            hiddens.forEach(hidden => {
                hidden.classList.add('hidden');
            });
        }
        var info = this.container.querySelector('.brand-info');
        info.style.height = '';
        if (Foundation.MediaQuery.atLeast('large')) {
            var maxHeight = 0;
            this.targets.forEach(target => {
                target.style.display = 'block';
                maxHeight = Math.max(target.clientHeight, maxHeight);
                target.style.display = '';
            });
            info.style.height = (maxHeight + 102) + 'px';
        }
    }

    _filterTargets(tab) {
        if (!this._locked) {
            var parent = tab.parentNode;
            var index = Array.from(parent.parentNode.children).indexOf(parent);
            if (index != this._currentTab) {
                var targetClass = tab.getAttribute("target-class");
                var notHidden;
                var currentHidden = false;
                this.tabs.forEach((tab, i) => {
                    if (i === index) {
                        tab.classList.add('active');
                    }
                    else {
                        tab.classList.remove('active');
                    }
                });
                this.triggers.forEach((trigger, i) => {
                    var parent = trigger.parentNode;
                    if (parent.classList.contains(targetClass)) {
                        parent.classList.remove('hidden');
                        if (notHidden === undefined) {
                            notHidden = i
                        }
                    }
                    else {
                        parent.classList.add('hidden');
                        if (i === this._currentTrigger) {
                            currentHidden = true;
                        }
                    }
                });
                if (Foundation.MediaQuery.atLeast('large')) {
                    if (currentHidden) {
                        this._switchBrand(notHidden);
                    }
                    if (this.tabBackgrounds && this.tabBackgrounds.length) {
                        var tl = new TimelineLite({
                            onComplete: function () {
                                gsap.set(this.tabBackgrounds[this._currentTab], { clearProps: 'zIndex,opacity,visibility,x,display' });
                                this._currentTab = index;
                            }.bind(this)
                        })
                            .set(this.tabBackgrounds[index], { display: 'inherit' })
                            .fromTo(this.tabBackgrounds[this._currentTab], { zIndex: 2, autoAlpha: 1, x: 0 }, { autoAlpha: 0, x: 200, duration: .5 }, 'start')
                    }
                }
                else {
                    this._currentTab = index;
                }
            }
        }
    }
}

export { Brands as default };